import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LandingPageComponent} from './pages/landing-page/landing-page.component';
import {FormPageComponent} from './pages/form-page/form-page.component';
import {FormStartResolver} from './resolvers/form-start.resolver';
import {CapturePageComponent} from './pages/capture-page/capture-page.component';
import {BiometryPageComponent} from './pages/biometry-page/biometry-page.component';
import {SendingPageComponent} from './pages/sending-page/sending-page.component';
import {ApplicationSentPageComponent} from './pages/application-sent-page/application-sent-page.component';
import {ReviewFormPageComponent} from './pages/review-form-page/review-form-page.component';
import {ProductPageComponent} from './pages/product-page/product-page.component';
import {ProductResolver} from './resolvers/product.resolver';
import { WelcomePageComponent } from './pages/welcome-page/welcome-page.component';
import { WaitingPageComponent } from './pages/waiting-page/waiting-page.component';
import { ConfirmedPageComponent } from './pages/confirmed-page/confirmed-page.component';
import { ReanalysisPageComponent } from './pages/reanalisys-page/reanalysis-page.component';
import { SmsVerificationPageComponent } from './pages/sms-verification-page/sms-verification-page.component';

const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent
  },
  {
    path: 'revisar',
    component: ReviewFormPageComponent,
  },
  {
    path: 'enviado',
    component: ApplicationSentPageComponent,
  },
  {
    path: 'produtos',
    component: ProductPageComponent,
    resolve: {
      products: ProductResolver
    }
  },
  {
    path: 'enviando',
    component: SendingPageComponent,
  },
  {
    path: 'aprovado',
    component: ConfirmedPageComponent,
  },
  {
    path: 'captura',
    component: CapturePageComponent,
  },
  {
    path: 'biometria',
    component: BiometryPageComponent,
  },
  {
    path: 'init',
    component: WelcomePageComponent,
  },
  {
    path: 'processamento',
    component: WaitingPageComponent,
  },
  {
    path: 'retomar/:id',
    component: WaitingPageComponent,
  },
  {
    path: 'startTrue',
    component: FormPageComponent,
    resolve: {
      appState: FormStartResolver
    }   
  },
  {
    path: 'reanalise',
    component: ReanalysisPageComponent,
    // resolve: {
    //   appState: FormStartResolver
    // }
  },
  {
    path: 'verificacao-sms',
    component: SmsVerificationPageComponent,
  },
  {
    path: ':stepName',
    component: FormPageComponent,
    resolve: {
      appState: FormStartResolver
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
